import styled from 'styled-components'

import { updatedMedia, maxWidthContent } from 'client/styles'

export const PhotosCategoriesBase = styled.div`
  width: 100%;
  max-width: ${maxWidthContent};
  margin-inline: auto;
  margin-block: 0;
  overflow-x: scroll;
  display: flex;
  flex-wrap: nowrap;
  padding-block: 8px 20px;
  padding-inline: 20px;
  scrollbar-width: none;
  position: sticky;
  inset-block-start: 0;
  background-color: var(--color--base--white);

  ::-webkit-scrollbar {
    display: none;
  }
  ${updatedMedia.tablet} {
    padding-block: 8px 20px;
    padding-inline: 40px;
  }

  ${updatedMedia.onlyMobile} {
    padding-block: 8px;
    padding-inline: 16px;
  }
`
